import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchRefDataItemInterface } from '../interfaces/searchRefDataItem.interface';

@JsonObject('SearchRefDataItemModel')
export class SearchRefDataItemModel implements SearchRefDataItemInterface {
  @JsonProperty('Id', String)
  Id: string = undefined;

  @JsonProperty('NumAssets', Number)
  NumAssets: number = undefined;

  @JsonProperty('Value', String)
  Value: string = undefined;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
